import { runtimeMessageSourceEventId } from "@cmmd-forge/shared/replicaMessageIdentity";
import type { ChatMessage } from "../../types";

export function assistantCitationMessageIdentity(
  message: Pick<ChatMessage, "id" | "sourceEventId">,
): string {
  return message.sourceEventId ?? runtimeMessageSourceEventId(message.id);
}

export function matchesAssistantCitationMessage(
  message: Pick<ChatMessage, "id" | "sourceEventId">,
  citationMessageId: string,
): boolean {
  return (
    message.id === citationMessageId ||
    assistantCitationMessageIdentity(message) === citationMessageId
  );
}
